import { useNavigate } from 'react-router-dom';
import { AppFooter } from '../branding/AppFooter';
import { BrandLockup } from '../branding/branding';
import { Button } from '../components/Button/Button';
import { PrivacyNote } from '../components/PrivacyNote/PrivacyNote';
import './Landing.css';

const audiences = [
  {
    title: 'For kids',
    body: 'Show your computer something with the camera or mic. It learns what you showed it. Then take it with you anywhere: your phone, the web, even a tiny chip.',
  },
  {
    title: 'For parents',
    body: 'Training happens in the browser. Photos and audio never touch a server unless your kid chooses to publish a project, and that takes your approval if they’re under 13.',
  },
  {
    title: 'For teachers',
    body: 'A creative path into machine learning that works on a Chromebook. Kids ship a real model, not a worksheet. Classroom features arrive in a later phase.',
  },
];

const promises = [
  'Your stuff stays on your device while you train.',
  'The model tells you when it isn’t sure, instead of guessing.',
  'You can throw it away and start over any time.',
  'When you ship a project, you get the whole thing. Open it in a text editor, change it, share it.',
];

export function Landing(): JSX.Element {
  const navigate = useNavigate();

  return (
    <main className="bl-landing">
      <header className="bl-landing__header">
        <BrandLockup asLink={false} />
        <PrivacyNote state="on-device" />
      </header>

      <section className="bl-landing__hero">
        <p className="bl-landing__eyebrow">Train · behave · ship · share</p>
        <h1 className="bl-landing__title">
          Make a model.
          <br />
          Ship it anywhere.
        </h1>
        <p className="bl-landing__lead">
          A machine learning studio for kids. Train it with your camera or mic, then put it on your
          phone, the web, or a tiny chip you can hold.
        </p>
        <div className="bl-landing__actions">
          <Button onClick={() => navigate('/studio')}>Open the studio</Button>
          <button
            type="button"
            className="bl-landing__secondary"
            onClick={() => navigate('/gallery')}
          >
            Browse the gallery →
          </button>
          <span className="bl-landing__status">Saves on this device. No account needed.</span>
        </div>
      </section>

      <section className="bl-landing__grid" aria-label="Who this is for">
        {audiences.map((card) => (
          <article key={card.title} className="bl-landing__card">
            <h2>{card.title}</h2>
            <p>{card.body}</p>
          </article>
        ))}
      </section>

      <section className="bl-landing__promises" aria-labelledby="promises-heading">
        <h2 id="promises-heading">What we promise</h2>
        <ul>
          {promises.map((promise) => (
            <li key={promise}>{promise}</li>
          ))}
        </ul>
      </section>

      <AppFooter />
    </main>
  );
}
